import React from 'react';
import { useTranslation } from 'react-i18next';
export var useLabelForEstimatedDeliveryPeriod = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var labelForEstimatedDeliveryPeriod = React.useCallback(function (transporToWarehouse) {
        if (!transporToWarehouse ||
            !transporToWarehouse.estimatedDeliveryPeriodYear ||
            !transporToWarehouse.estimatedDeliveryPeriodMonth ||
            !transporToWarehouse.estimatedDeliveryPeriodMonthPart)
            return t('labels.pending');
        var date = new Date("".concat(transporToWarehouse.estimatedDeliveryPeriodYear, "-").concat(transporToWarehouse.estimatedDeliveryPeriodMonth, "-03"));
        var year = date.toLocaleString(i18n.language, { year: 'numeric' });
        var month = date.toLocaleString(i18n.language, { month: 'long' });
        var monthPart = t("params.transportToWarehouse.estimatedDeliveryPeriodMonthParts.".concat(transporToWarehouse.estimatedDeliveryPeriodMonthPart));
        return t('pages.offerList.estimatedDeliveryPeriodFormat', {
            year: year,
            month: month,
            monthPart: monthPart,
        });
    }, [t, i18n]);
    return labelForEstimatedDeliveryPeriod;
};
export var useLabelForEstimatedPaymentDate = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var labelForEstimatedPaymentDate = React.useCallback(function (offerList) {
        if (!offerList || !offerList.estimatedPaymentDate)
            return '';
        var newDate = new Date(offerList.estimatedPaymentDate);
        var year = newDate.toLocaleString(i18n.language, { year: 'numeric' });
        var month = newDate.toLocaleString(i18n.language, { month: 'long' });
        var date = newDate.toLocaleString(i18n.language, { day: 'numeric' });
        return t('pages.offerList.estimatedPaymentDateFormat', {
            year: year,
            month: month,
            date: date,
        });
    }, [t, i18n]);
    return labelForEstimatedPaymentDate;
};
